import { Component } from '../../../libs/gin-tonic/helpers/compiler/index';

@Component({ className: 'js-language-chooser' })
export class LanguageChooserComponent {
	private languageButton: HTMLElement;
	private languageList: HTMLElement;
	private languageOptions: HTMLElement[];

	constructor(private element: HTMLElement) {
		this.languageButton = this.element;
		this.languageList = document.querySelector('.js-language-chooser-list') as HTMLElement;
		this.languageOptions = Array.from(this.languageList.querySelectorAll('.js-language-chooser-option'));

		this.handleButtonClick();
		this.handleAccessibilityNavigations();
		this.handleOutsideClick();
	}

	handleButtonClick() {
		this.languageButton.addEventListener('click', () => {
			const isExpanded = this.languageButton.getAttribute('aria-expanded') === 'true';
			this.languageButton.setAttribute('aria-expanded', `${!isExpanded}`);
			this.languageList.style.display = isExpanded ? 'none' : 'block';

			this.languageOptions[0].focus();
		});
	}

	handleAccessibilityNavigations() {
		this.languageButton.addEventListener('keydown', event => {
			const isExpanded = this.languageButton.getAttribute('aria-expanded') === 'true';

			if (event.key === 'Escape' && isExpanded) {
				event.preventDefault();
				this.languageButton.setAttribute('aria-expanded', 'false');
				this.languageList.style.display = 'none';
			}

			if (event.key === 'ArrowDown' && isExpanded) {
				event.preventDefault();
				this.languageOptions[0].focus();
			}
		});

		this.languageList.addEventListener('keydown', event => {
			const options = this.languageList.querySelectorAll('.js-language-chooser-option');
			let currentIndex = Array.from(options).indexOf(document.activeElement as HTMLElement);

			if (event.key === 'ArrowDown') {
				event.preventDefault();
				currentIndex = (currentIndex + 1) % options.length;
				(options[currentIndex] as HTMLElement).focus();
			}

			if (event.key === 'ArrowUp') {
				event.preventDefault();
				currentIndex = (currentIndex - 1 + options.length) % options.length;
				(options[currentIndex] as HTMLElement).focus();
			}
		});
	}

	handleOutsideClick() {
		document.addEventListener('click', (event: Event) => {
			const clicked = event.target as HTMLElement;
			if (clicked.classList.contains('js-language-chooser')) {
				return;
			}
			this.languageButton.setAttribute('aria-expanded', 'false');
			this.languageList.style.display = 'none';
		});
	}
}
